import styled from "styled-components"
import SelectItem from "../common/input/selectItem"
import { useCallback, useMemo, useState } from "react"
import CreateOrUpdateTheaterCompany from "./createOrUpdateTheaterCompany"
import { Accordion, AccordionDetails, AccordionSummary, InputLabel, Typography } from "@mui/material"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { MasterUser, Production, Stage, TheaterCompany } from "@/graphql/types"
import CreateOrUpdateProduction from "./createOrUpdateProduction"
import GraphQLClient from "@apollo/client"
import { GetMasterInitialItems } from "@/graphql/documentNode"
import CreateOrUpdateStage from "./createOrUpdateStage"
import { useSnackBar } from "@/lib/ts/hooks/useSnackBar"
import SelectItemV2 from "../common/input/selectItemV2"

const itemTypeList = [
    {
        name: "団体",
        value: 0,
    },
    {
        name: "公演",
        value: 1,
    },
    {
        name: "ステージ",
        value: 2,
    },
]

const newItem = {
    id: -2,
    name: "新規作成",
    stageName: "新規作成",
}

type Props = {
    user: MasterUser
    theaterCompanies: TheaterCompany[]
    productions: Production[]
    stages: Stage[]
    refresh: () => Promise<void>
}

const CreateItemMenu = (props: Props) => {
    const snackBar = useSnackBar({})
    const [itemType, setItemType] = useState(-1)
    const [selectedId, setSelectedId] = useState(-1)
    console.log(props)

    const itemList = useMemo(() => {
        if(itemType === 0) {
            return [newItem, ...props.theaterCompanies]
        }
        if(itemType === 1) {
            return [newItem, ...props.productions]
        }
        if(itemType === 2) {
            return [newItem, ...props.stages]
        }
        return []
    }, [itemType, props.productions, props.stages, props.theaterCompanies])

    const targetItem = useMemo(() => {
        if(selectedId === -2) {
            return undefined
        }
        if(itemType === 0) {
            return props.theaterCompanies.find(item => item.id ===selectedId)
        }
        if(itemType === 1) {
            return props.productions.find(item => item.id ===selectedId)
        }
        if(itemType === 2) {
            return props.stages.find(item => item.id ===selectedId)
        }
    }, [itemType, props.productions, props.stages, props.theaterCompanies, selectedId])

    const refresh = useCallback(async () => {
        setSelectedId(-1)
        setItemType(-1)
        await props.refresh()
        snackBar.onMutationSuccess()
    }, [props, snackBar])

    const bodyArea = useMemo(() => {
        console.log(selectedId)
        if(selectedId === -1) {
            return <></>
        }
        if(itemType === 0) {
            return <CreateOrUpdateTheaterCompany theaterCompanyData={targetItem as any} onComplete={refresh} />
        } else if (itemType === 1) {
            return <CreateOrUpdateProduction 
                user={props.user} 
                theaterCompanies={props.theaterCompanies}
                productionData={targetItem as any}
                onComplete={refresh}
            />
        } else if (itemType === 2) {
            return <CreateOrUpdateStage
                user={props.user}
                productions={props.productions}
                stageData={targetItem as any}
                onComplete={refresh}
            />
        } else {
            return <></>
        }
    }, [itemType, props.productions, props.theaterCompanies, props.user, refresh, selectedId, targetItem])

    const selectedItemTypeIndex = useMemo(() => {
        return itemTypeList.findIndex(item => item.value === itemType)
    }, [itemType])

    const selectedItemIndex = useMemo(() => {
        return itemList.findIndex(item => item.id === selectedId)
    }, [itemList, selectedId])

    return (
        <CreateItemMenuStyle>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                <Typography>団体・公演・ステージ作成/編集</Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ width: "100%" }}>
                <div className="select-type">
                    <InputLabel>種類</InputLabel>
                    <SelectItemV2 
                        items={itemTypeList}
                        selectedIndex={selectedItemTypeIndex}
                        changeIndex={(item, index) => { setItemType(item.value) }}
                        width={250}
                    />
                </div>
                {itemType >= 0 && <div className="select-type">
                    <InputLabel>編集対象の{itemTypeList[selectedItemTypeIndex]?.name ?? "アイテム"}</InputLabel>
                    <SelectItemV2 
                        items={itemList}
                        selectedIndex={selectedItemIndex}
                        changeIndex={(item, index) => { setSelectedId(item.id) }}
                        width={250}
                        labelName={itemType === 2 ? "stageName" : "name"}
                    />
                </div>}
                { bodyArea }
                </AccordionDetails>
            </Accordion>
            {snackBar.component}
        </CreateItemMenuStyle>
    )
}

const CreateItemMenuStyle = styled.div`
    .select-type {
        width: 250px;
        margin: 8px auto 8px auto;
    }
`

export default CreateItemMenu